import moment from 'moment';

export default class Date {
    constructor(year, month, day) {
        this.year = Number.parseInt(year);
        this.month = Number.parseInt(month);
        this.day = Number.parseInt(day);
    }

    format(pattern) {
        return this.momentDate().format(pattern);
    }

    toIso8601() {
        return `${this.year.toString().padStart(4, '0')}-${
            this.month.toString().padStart(2, '0')}-${
            this.day.toString().padStart(2, '0')}`;
    }

    toApiDto() {
        return {
            year: this.year,
            month: this.month,
            day: this.day,
        };
    }

    momentDate() {
        return moment(this.toIso8601(), 'YYYY-MM-DD');
    }

    static today() {
        return Date.fromIso8601(moment().format('YYYY-MM-DD'));
    }

    static fromIso8601(isoString) {
        if (!/^\d{4}-(0\d|1[0-2])-([0-2]\d|3[01])$/.test(isoString)) {
            throw new Error(`${isoString} is not a valid date format`);
        }
        const parts = isoString.split('-');

        return new Date(parts[0], parts[1], parts[2]);
    }

    toString(locale) {
        locale = locale || 'de';
        return this.momentDate().locale(locale).format('L');
    }

    isBeforeOrEqual(referenceDate) {
        return this.momentDate().isSameOrBefore(referenceDate.momentDate());
    }

    isBefore(referenceDate) {
        return this.momentDate().isBefore(referenceDate.momentDate());
    }

    isAfter(referenceDate) {
        return this.momentDate().isAfter(referenceDate.momentDate());
    }

    isAfterOrEqual(referenceDate) {
        return this.momentDate().isSameOrAfter(referenceDate.momentDate());
    }

    addMonths(numberOfMonths) {
        return Date.fromIso8601(this.momentDate().add(numberOfMonths, 'months').format('YYYY-MM-DD'));
    }

    addDays(numberOfDays) {
        return Date.fromIso8601(this.momentDate().add(numberOfDays, 'days').format('YYYY-MM-DD'));
    }

    subDays(numberOfDays) {
        return Date.fromIso8601(this.momentDate().subtract(numberOfDays, 'days').format('YYYY-MM-DD'));
    }

    equals(other) {
        return this.day === other.day && this.month === other.month && this.year === other.year;
    }

    mondayOfWeek() {
        return Date.fromIso8601(this.momentDate().startOf('isoweek').format('YYYY-MM-DD'));
    }

    clone() {
        return new Date(this.year, this.month, this.day);
    }
}
